import React from 'react';
import ReactDOM from 'react-dom';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Provider as ReduxProvider } from 'react-redux';
import {
  BrowserRouter, Route,
} from 'react-router-dom';
import 'promise-polyfill/src/polyfill';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import locales from './locales';
import IEAlert from './components/IEAlert';
import configureStore from './store/configureStore';
import App from './App';
import { BASE_PATH } from './routes';
import FirebaseProvider from './components/FirebaseProvider';
import 'simplebar-react/dist/simplebar.min.css';
import { isMainDomain } from './helpers/getters';

i18n.use(initReactI18next).init({
  resources: {
    ...locales,
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

const store = configureStore();

const msieversion = () => {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) return true;
  return false;
};

const IGNORED_ERRORS = [
  // Raised by @zxing/browser in the QR scanner (src/forks/QrReader), which
  // switches the camera torch off inside stop(), after the camera track has
  // already been stopped. Chrome names that same failed call differently
  // depending on the device.
  'The associated Track is in an invalid state',
  'setPhotoOptions failed',
  // Injected by Microsoft's link scanner, which opens event invitation links in
  // an automated browser. Not our code and not a real user.
  'Object Not Found Matching Id',
  // Firebase stores telemetry in IndexedDB. Mobile browsers tear that database
  // down while the tab is suspended, and the library leaves the rejection
  // unhandled. We do not use IndexedDB ourselves.
  'Connection to Indexed Database server lost',
  'Database deleted by request of the user',
];

if (process.env.REACT_APP_ENV === 'prod') Sentry.init({
  environment: 'prod',
  dsn: 'https://d9f0ba9648e24bf6ab134f6c38050e14@o193591.ingest.sentry.io/5743526',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  ignoreErrors: IGNORED_ERRORS,
  beforeSend(event, hint) {
    const error = hint?.originalException;
    if (!isMainDomain() && (
      error?.message?.includes('appCheck/recaptcha-error')
      || error?.code === 'appCheck/recaptcha-error'
    )) return null;

    return event;
  },
});

const inEventtia = /eventtia.com/.test(window.location.host);
if ('serviceWorker' in navigator) window.addEventListener('load', () => {
  if (inEventtia) navigator.serviceWorker.register('/sw.js')
    .catch((error) => {
      console.warn('Service worker not registered:', error);
    });
  else navigator.serviceWorker.getRegistrations()
    .then((registrations) => Promise.all(
      registrations.map((registration) => registration.unregister())
    ))
    .catch((error) => {
      console.warn('Service worker cleanup skipped:', error);
    });
});

if (!msieversion()) ReactDOM.render(
  <ReduxProvider store={store}>
    <FirebaseProvider>
      <BrowserRouter>

        <Route path={BASE_PATH}>
          <App />
        </Route>

      </BrowserRouter>
    </FirebaseProvider>
  </ReduxProvider>,
  document.getElementById('root')
);
else ReactDOM.render(
  <IEAlert />,
  document.getElementById('root')
);
